import { faGavel } from '@fortawesome/free-solid-svg-icons/faGavel';
import { FieldLabelIconMui5 } from 'components/atoms/FieldLabelIcon';
import Switch, { SwitchButtonItem } from 'components/molecules/Switch';
import { UppercaseMui5 } from '../components';
import Popover from 'components/molecules/Popover';
import { AuctionTypes } from 'shared/types/models';
import {
  SetFilterValue,
  useFilters,
} from '../../../../../services/filters/hooks/useFilters';
import { styled } from '@mui/material/styles';

const StyledPopover = styled(Popover)(({ theme }) => ({
  position: 'relative',
  top: theme.spacing(0.2),
}));

export const AuctionTypeFilter = ({
  setFilterValue,
  disabled = false,
}: {
  setFilterValue: SetFilterValue;
  disabled?: boolean;
}) => {
  const { filters } = useFilters();

  return (
    <Switch
      title={
        (
          <UppercaseMui5>
            <FieldLabelIconMui5 icon={faGavel} color='primary' />
            Auction type{' '}
            <StyledPopover maxWidth={'300px'}>
              Classic Auction - outbid other users until the auction ends,
              highest bidder wins. Dynamic Auction - the monthly price decreases
              over time, click lease it now to become the instant winner before
              others{' '}
            </StyledPopover>
          </UppercaseMui5>
        ) as any
      }
      value={filters.type || ''}
      onChange={(e: React.MouseEvent<HTMLElement>, type: boolean) => {
        if (type == null || disabled) {
          return;
        }

        setFilterValue('type', type);
      }}
      size='small'
      items={
        [
          { value: '', label: 'All' },
          { value: AuctionTypes.Classic, label: 'Classic' },
          { value: AuctionTypes.Dutch, label: 'Dynamic' },
        ] as SwitchButtonItem[]
      }
      aria-label='text formatting'
    />
  );
};
